module.exports = __webpack_public_path__ + "static/segment-19ec1443990b8ed55c7f1a8e957621f6.png";